import { baseAxios } from './Axios';
//Components
import { TemplateTriviaQuestions } from '../components/Templates';
import { QuestionsTriviaTest } from '../components/QuestionsTriviaTest';
import { CalcTime } from '../components/CalcTime';
import { SoundStop } from '../components/Sounds';

const TriviaTest = (()=>{
    //Request list questions dummy
    const request = async (category)=>{
        const response = await baseAxios.get(`/dummy-questions?category=${category}`)
        return response.data;
    }
    //Funciont for rendering questions
    const renderQuestions = (body)=>{
        const container = document.querySelector('#render-questions-test');
        //While data
        [...body].forEach((data, indice)=>{
            const { id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4 } = data;
            //Validate state question
            if(data.state){
                const template = TemplateTriviaQuestions(indice, id, pregunta, respuesta1, respuesta2, respuesta3, respuesta4, indice == 0 && 'active');
                //Render
                container.append(template);
            }
        });
        CalcTime('#trivia-test', '#render-questions-test');
    }
    //Hide and show sections
    const HiddeShowSections = (e, time)=>{
        const loader = document.querySelector('.loader');
        const enableContainer = document.querySelector('#trivia-test');
        const bg = document.querySelector('.bg');
        const audio = document.querySelector('#sound-trivia');
        const comeBack = document.querySelector('.come-back');
        const body = document.body;
        //Disable and enable
        setTimeout(()=>{
            enableContainer.classList.remove('hidden');
            e.target.closest('.container').classList.add('hidden');
            loader.classList.add('disabled');
            bg.classList.add('bg--without-opacity');
            comeBack.classList.remove('hidden-important');
            //enable audio and disable audio
            audio && audio.play();
            console.log(audio);
            body.addEventListener('click', ()=>{
                setTimeout(()=>{
                    if(!body.classList.contains('audio-sound-play')){
                        audio.classList.add('active');
                        audio.currentTime == 0 && audio.play();
                    }
                    body.classList.add('audio-sound-play');
                },500);
            });
            SoundStop();
        }, time);
    }
    //Enable categories trivia
    const _TriviaEnable = ()=>{
        const btn = document.querySelector('#enable-trivia-test');
        btn.addEventListener('click', ()=>{
            btn.closest('.container').classList.add('hidden');
            document.querySelector('#trivia-categories-test').classList.remove('hidden');
        }); 
    }
    //Config
    const _TriviaTestConfig = ()=>{
        const data = localStorage.getItem('questions-test');
        const initTrivia = document.querySelectorAll('#init-trivia-test .btn');
        const loader = document.querySelector('.loader');
        //Handle event
        initTrivia.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                //Remove loader and save category in localstorage
                loader.classList.remove('disabled');
                const category = localStorage.getItem('category-trivia-test'); 
                !category && localStorage.setItem('category-trivia-test', btn.textContent.trim());
                //Request
                !data && request(category ? category : btn.textContent.trim())
                    .then(res=>{
                        setTimeout(()=>{
                            //Save questions
                            if(res.length){
                                res.forEach((data)=>{
                                    const { state } = data;
                                    state == undefined && (data.state = true);
                                });
                                //Save with state
                                localStorage.setItem('questions-test', JSON.stringify(res));
                                //Function trivia
                                renderQuestions(res);
                                QuestionsTriviaTest();
                            }else{
                                localStorage.removeItem('questions-test');
                                localStorage.removeItem('category-trivia-test');
                                document.querySelector('#moda-error-trivia').classList.add('active');
                            }
                        },500);
                        res.length && HiddeShowSections(e, 1000);
                    });
                //Render questions
                if(JSON.parse(data)?.length > 1){
                    setTimeout(()=>{
                        renderQuestions(JSON.parse(data));
                        QuestionsTriviaTest();
                    },500);
                    HiddeShowSections(e, 1000);
                }
            });
        });
        if(JSON.parse(data)?.length <= 1){
            localStorage.removeItem('questions-test');
            localStorage.removeItem('category-trivia-test');
            window.location.reload();
        }
        //Enable questions
        JSON.parse(data)?.length > 1 && initTrivia.forEach((btn)=>{
            if(btn.textContent == localStorage.getItem('category-trivia-test')){
                btn.click();
                setTimeout(()=>{
                    document.querySelector('.trivia-test-init').classList.add('hidden');
                },1000);
            }
        });
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _TriviaTestConfig(); } catch (error) { console.log(error); }
            try { _TriviaEnable(); } catch (error) { console.log(error); }
        }
    }
})();

/*
*Load global functions
*/
const loadTriviaTestHandlers = ()=>{
    TriviaTest.setHandleEvent();
}

export { loadTriviaTestHandlers }